import Element from './Element';
import GameObject from '../../GameObject/GameObject';

export default class WorldHudIcon extends Element {
    public create(params: any): void {
        super.create({
            type: 'group',
            name: params.name,
            layout: {
                anchors: [1, 1, 1, 1],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
            },
            components: [
                {
                    type: 'input',
                    data: {
                        enabled: true,
                    },
                },
                {
                    type: 'visibility',
                    data: {
                        hidden: false,
                    },
                },
            ],
            children: [],
        });

        if (params.rays !== false) {
            const rays = GameObject.Instantiate(Element, {
                type: 'group',
                name: 'ray',
                layout: {
                    anchors: [0.5, 0.5, 0.5, 0.5],
                    pivot: [0.5, 0.5],
                    offsets: [0, 0, 0, 0],
                    angle: 0,
                },
                components: [
                    {
                        type: 'image',
                        data: {
                            cacheKey: 'icon_rays',
                        },
                    },
                ],
            });

            this.addChild(rays);
        }

        const icon = GameObject.Instantiate(Element, {
            type: 'group',
            name: 'icon',
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
                angle: 0,
            },
            components: [
                {
                    type: 'image',
                    data: {
                        cacheKey: params.key,
                    },
                },
            ],
        });

        this.addChild(icon);
    }
}
